import React from 'react';
import { useDepressionMode } from '../contexts/DepressionModeContext';

/**
 * DepressionModeToggle - おやすみモード切替
 *
 * 設計方針:
 * - トグルスイッチ：通常モード ⇔ おやすみモード
 * - おやすみモード時のみ、チェックボックス「超おやすみモード」を表示
 */
const DepressionModeToggle = () => {
  const { depressionLevel, setDepressionModeLevel } = useDepressionMode();

  // トグルスイッチの状態（level 0 = off, level 1+ = on）
  const isDepressionModeOn = depressionLevel > 0;

  // 超おやすみモードのチェック状態
  const isUltraMode = depressionLevel === 2;

  const handleToggleChange = () => {
    if (isDepressionModeOn) {
      // おやすみモードをOFFにする → 通常モード
      console.log('🔄 おやすみモードをOFF');
      setDepressionModeLevel(0);
    } else {
      // おやすみモードをONにする → レベル1
      console.log('🔄 おやすみモードをON');
      setDepressionModeLevel(1);
    }
  };

  const handleUltraCheckChange = (e) => {
    if (e.target.checked) {
      // 超おやすみモードON → レベル2
      console.log('🔄 超おやすみモードON');
      setDepressionModeLevel(2);
    } else {
      // 超おやすみモードOFF → レベル1に戻る
      console.log('🔄 超おやすみモードOFF');
      setDepressionModeLevel(1);
    }
  };

  return (
    <div className="depression-mode-container">
      <div className="depression-mode-header">
        <span className="depression-mode-icon">🌙</span>
        <div className="depression-mode-info">
          <h4 className="depression-mode-title">おやすみモード</h4>
          <p className="depression-mode-desc">疲れた時は、優しくシンプルに</p>
        </div>
      </div>

      {/* トグルスイッチ */}
      <label className="depression-mode-switch">
        <input
          type="checkbox"
          checked={isDepressionModeOn}
          onChange={handleToggleChange}
        />
        <span className="depression-mode-switch__slider"></span>
      </label>

      {/* おやすみモードがONの時のみ、超おやすみモードのチェックボックスを表示 */}
      {isDepressionModeOn && (
        <div className="depression-mode-ultra">
          <label className="depression-mode-ultra__label">
            <input
              type="checkbox"
              className="depression-mode-ultra__checkbox"
              checked={isUltraMode}
              onChange={handleUltraCheckChange}
            />
            <span className="depression-mode-ultra__text">
              💤 超おやすみモード（つむぎとの会話だけ）
            </span>
          </label>
          <p className="depression-mode-ultra__hint">
            {isUltraMode
              ? '💜 辛い時は、つむぎに話すだけで大丈夫。他のことは気にしなくていいよ。'
              : '💙 今は無理しなくていいよ。できることだけで大丈夫。'
            }
          </p>
        </div>
      )}
    </div>
  );
};

export default DepressionModeToggle;
